// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

ion-card ion-icon.has-equipment {
  float: right;
  font-size: 20px;
}
ion-card ion-card-title, ion-card ion-card-subtitle, ion-card p {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/customer-address-card/customer-address-card.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEI;EACI,YAAA;EACA,eAAA;AACR;AAEI;EACI,YAAA;AAAR","sourcesContent":[":host {\r\n    width: 100%;\r\n}\r\nion-card {\r\n    ion-icon.has-equipment {\r\n        float: right;\r\n        font-size: 20px;\r\n    }\r\n\r\n    ion-card-title, ion-card-subtitle, p {\r\n        color: black;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
